import Promise from 'bluebird';

let loadedSources = {};

function loadjscssfile(filename, filetype) {
	return new Promise((resolve, reject) => {
		let fileref = void 0;
		if (filetype === 'js')
		{
			//if filename is a external JavaScript file
			fileref = document.createElement('script');
			fileref.setAttribute('type','text/javascript');
			fileref.setAttribute('src', filename);
		}
		else if (filetype === 'css')
		{
			//if filename is an external CSS file
			fileref = document.createElement('link');
			fileref.setAttribute('rel', 'stylesheet');
			fileref.setAttribute('type', 'text/css');
			fileref.setAttribute('href', filename);
		}
		if (typeof fileref != 'undefined') {
			fileref.addEventListener('load', function() {
				resolve();
			}, false);
			fileref.addEventListener('error', function() {
				resolve();
			}, false);
			document.getElementsByTagName('head')[0].appendChild(fileref);
		} else {
			reject();
		}
	});
}

export default {
	loadOnce(items, type) {
		return Promise.all(items.map(f => {
			if (!loadedSources[f]) {
				loadedSources[f] = loadjscssfile(f, type || f.substr(-2) === 'js' ? 'js' : 'css').then(() => {
					loadedSources[f] = true;
				});
				return loadedSources[f];
			};
			return loadedSources[f];
		}));
	},
	reload(items) {
		items.map(f => loadedSources[f] = false);
		return this.load(items);
	}
};
